import { createUseStyles } from "react-jss";

export const ProgressBarStyle = createUseStyles((theme: any) => ({
    progressBar: {
        backgroundColor: "#f2f2f2",
        // borderRadius: 10,
        height: 20,
        width: "100%",
    },
    progressBarFill: {
        height: "100%",
        backgroundColor: "var(--text-color-purpleLigth)",
        transition: "width 1.5s ease-in-out",
    },
}));
